/**
 * DevExtreme (esm/__internal/grids/new/grid_core/search/options.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import messageLocalization from "../../../../../localization/message";
export const defaultOptions = {
    searchPanel: {
        highlightCaseSensitive: false,
        highlightSearchText: true,
        placeholder: messageLocalization.format("dxDataGrid-searchPanelPlaceholder"),
        searchVisibleColumnsOnly: false,
        text: "",
        visible: false,
        width: 160
    }
};
